<mat-menu #attachmentDetailsMenu="matMenu">
  <ng-template matMenuContent>
    <ng-template #imageTmpl>
      <img [attr.src]="fileLink$ | async"
                       style="width: 100%; min-height: 100px" />
    </ng-template>
    <div *ngIf="isImage(attachment)"
         (click)="openImageInDialog(imageTmpl)">
      <ng-container [ngTemplateOutlet]="imageTmpl">

      </ng-container>
    </div>
    <button mat-menu-item
            role="button"
            title="Download {{attachment.name}}"
            (click)="attachmentClicked(attachment)">
      <mat-icon fontSet="fal fa-fw"
                fontIcon="fa-download"
                style="vertical-align: baseline;"></mat-icon>
      <span style="margin-left: .50em">
        <strong>{{attachment.name | truncateMiddle:20}}</strong>
        <small class="ml-0025">{{attachment.size | filesize}}</small>
      </span>
    </button>

  </ng-template>
</mat-menu>

<button mat-icon-button
        style="line-height: 18px; margin-top: -9px; margin-bottom: -9px;"
        aria-label="Open attachment details menu"
        title="View Attachment"
        [matMenuTriggerFor]="attachmentDetailsMenu"
        type="button">
  <mat-icon fontSet="fal fa-fw"
            class="fa--gray"
            fontIcon="fa-paperclip"></mat-icon>
</button>

<!-- style="line-height: 18px; margin-left: -15px" -->
